import React, {Component} from "react";
/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
import { updateForm } from "../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing Autosuggest for autosuggesting States
*/
import Autosuggest from 'react-autosuggest';
/*
    Using Validation functions from utils folder
*/
import Validation from '../../utils/Validation';
const validation = new Validation();

const usstates = [
  { name: 'Alabama', age: 19, shortform: 'AL', served: true, type: 'Installment Loan', min: 2000, max: 2600 },
  { name: 'Alaska', age: 18, shortform: 'AK', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Arizona', age: 18, shortform: 'AZ', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Arkansas', age: 18, shortform: 'AR', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'California', age: 18, shortform: 'CA', served: true, type: 'Payday Loan', min: 255, max: 255 },
  { name: 'Colorado', age: 18, shortform: 'CO', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Connecticut', age: 18, shortform: 'CT', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Delaware', age: 18, shortform: 'DE', served: true, type: 'Line of Credit', min: 150, max: 1000},
  { name: 'Florida', age: 18, shortform: 'FL', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Georgia', age: 18, shortform: 'GA', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Hawaii', age: 18, shortform: 'HI', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Idaho', age: 18, shortform: 'ID', served: true, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Illinois', age: 18, shortform: 'IL', served: true, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Indiana', age: 18, shortform: 'IN', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Kansas' , age: 18, shortform: 'KS', served: true, type: 'Line of Credit', min: 200, max: 1000 },
  { name: 'Kentucky', age: 18, shortform: 'KY', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Louisiana', age: 18, shortform: 'LA', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Maine', age: 18, shortform: 'ME', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Maryland', age: 18, shortform: 'MD', served: true, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Massachusetts', age: 18, shortform: 'MA', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Michigan', age: 18, shortform: 'MI', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Minnesota', age: 18, shortform: 'MN', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Mississippi', age: 21, shortform: 'MS', served: true, type: 'Installment Loan', min: 550, max: 1475},
  { name: 'Missouri', age: 18, shortform: 'MO', served: true, type: 'Installment Loan', min: 500, max: 1000},
  { name: 'Montana', age: 18, shortform: 'MT', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Nebraska', age: 18, shortform: 'NE', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Nevada', age: 18, shortform: 'NV', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'New Hampshire', age: 18, shortform: 'NH', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'New Jersey', age: 18, shortform: 'NJ', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'New Mexico', age: 18, shortform: 'NM', served: true, type: 'Installment Loan', min: 200, max: 1400},
  { name: 'New York', age: 18, shortform: 'NY', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'North Carolina', age: 18, shortform: 'NC', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'North Dakota', age: 18, shortform: 'ND', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Ohio', age: 18, shortform: 'OH', served: true, type: 'Installment Loan', min: 150, max: 1500},
  { name: 'Oklahoma', age: 18, shortform: 'OK', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Oregon', age: 18, shortform: 'OR', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Pennsylvania', age: 18, shortform: 'PA', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Rhode Island', age: 18, shortform: 'RI', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'South Carolina', age: 18, shortform: 'SC', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'South Dakota', age: 18, shortform: 'SD', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Tennessee', age: 18, shortform: 'TN', served: true, type: 'Line of Credit', min: 200, max: 1475},
  { name: 'Texas', age: 18, shortform: 'TX', served: true, type: 'Installment Loan', min: 150, max: 500},
  { name: 'Utah', age: 18, shortform: 'UT', served: true, type: 'Installment Loan', min: 150, max: 1000},
  { name: 'Vermont', age: 18, shortform: 'VT', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Virginia', age: 18, shortform: 'VA', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Washington', age: 18, shortform: 'WA', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'West Virginia', age: 18, shortform: 'WV', served: false, type: 'Installment Loan', min: 200, max: 1000 },
  { name: 'Wisconsin', age: 18, shortform: 'WI', served: true, type: 'Installment Loan', min: 150, max: 700},
  { name: 'Wyoming', age: 18, shortform: 'WY', served: false, type: 'Installment Loan', min: 200, max: 1000 }
];
// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  let val = value.split('|');
  const inputValue = val[0].trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0 ? [] : usstates.filter(st =>
    st.name.toLowerCase().slice(0, inputLength) === inputValue
  );
};

const allSuggestions = usstates.filter(st => st.name);

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name+"|"+suggestion.shortform+"|"+suggestion.age+"|"+suggestion.min+"|"+suggestion.max+"|"+suggestion.type+"|"+suggestion.served;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {suggestion.name}
  </div>
);

class StateSelector2 extends Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.stchange = false;
    this.stateselected = false;

    this.state = {
      suggestions: allSuggestions
    };

    this.onChange = this.onChange.bind(this);
    this.setStofRes = this.setStofRes.bind(this);
    this.onBlurred = this.onBlurred.bind(this);
  }

  componentDidMount() {
    if (this.props.st.length > 0){
      this.stateselected = true;
      document.getElementById("st").classList.add('filled');
      document.querySelector("label[for='st']").classList.add('activeaddy');
    }
  }

  onChange = (event, { newValue }) => {
    let value = newValue.split('|');
    this.props.updateForm("st", value[0]);

    // remove filled for field
    const statelabel = document.getElementById("state-placeholder");
    if (value[0].length === 0){
      statelabel.classList.remove('state-label');
    } else {
      statelabel.classList.add('state-label');
    }
    // eslint-disable-next-line
    if ( value[1] != this.props.stt ){
      this.props.updateForm("statechanged", true);
      this.stchange=true;

      let newaddress = this.props.street+", "+this.props.city+", "+value[1]+", "+this.props.zip;
      this.props.updateForm("address", newaddress);
    } else {
      this.props.updateForm("statechanged", false);
      this.stchange=false;
    }
    this.props.updateForm("stt", value[1]);

    const stateinput = document.querySelector("label[for='st']");
    const sliderdiv = document.getElementById("loanslider");
    if (value[6]){
      this.stateselected = true;
      const legalage = parseInt(value[2], 10);
      const min = parseInt(value[3], 10);
      const max = parseInt(value[4], 10);
      this.props.updateForm("legalage", legalage);
      this.props.updateForm("minamt", min);
      this.props.updateForm("maxamt", max);
      this.props.updateForm("loantype", value[5]);

      // calc the middle amount between min and max loan amounts
      let diff =  max - ((max - min) / 2);
      //round amount to nearest hundred
      let newamt = Math.round(diff/100) * 100;
      if (min === max) newamt = max;

      this.props.updateForm("loanamt", newamt);
      this.props.updateForm("askedforamt", newamt);

      this.props.updateForm("statechecked", true);
      if (validation.checkAll([true,this.props.streetnumberchecked,this.props.streetchecked,this.props.citychecked,this.props.zipchecked])){
        setTimeout(this.props.updateForm,10,"alladdresschecked", true);
      }
      stateinput.classList.add("active");

      if (value[6] === "true"){
        this.props.updateForm("notserved", false);
        this.props.updateForm("stateserved", true);
        if (this.stchange){
          if (value[1] !== "CA"){
            sliderdiv.classList.add("hidden");
            scroll.scrollTo(250, {duration: 1000});
            setTimeout(()=>{document.querySelector('.rangeslider__handle').focus()},10);
          } else {
            sliderdiv.classList.remove("hidden");
          }
        }
      } else {
        this.props.updateForm("notserved", true);
        this.props.updateForm("stateserved", false);
        this.props.updateForm("statechanged", true);
        sliderdiv.classList.add("hidden");
      }
    } else {
      stateinput.classList.remove("active");
      this.props.updateForm("statechecked", false);
      setTimeout(this.props.updateForm,10,"alladdresschecked", false);
    }
  };

  setStofRes(i){
    this.props.updateForm("st", usstates[i].name);

    // remove filled for field
    const statelabel = document.getElementById("state-placeholder");
    statelabel.classList.add('state-label');
    // eslint-disable-next-line
    if ( usstates[i].shortform != this.props.stt ){
      this.props.updateForm("statechanged", true);
      this.stchange=true;

      let newaddress = this.props.street+", "+this.props.city+", "+usstates[i].shortform+", "+this.props.zip;
      this.props.updateForm("address", newaddress);
    } else {
      this.props.updateForm("statechanged", false);
      this.stchange=false;
    }
    this.props.updateForm("stt", usstates[i].shortform);

    const legalage = parseInt(usstates[i].age, 10);
    const min = parseInt(usstates[i].min, 10);
    const max = parseInt(usstates[i].max, 10);
    this.props.updateForm("legalage", legalage);
    this.props.updateForm("minamt", min);
    this.props.updateForm("maxamt", max);
    this.props.updateForm("loantype", usstates[i].type);

    // calc the middle amount between min and max loan amounts
    let diff =  max - ((max - min) / 2);
    //round amount to nearest hundred
    let newamt = Math.round(diff/100) * 100;
    if (min === max) newamt = max;

    this.props.updateForm("loanamt", newamt);
    this.props.updateForm("askedforamt", newamt);

    this.props.updateForm("statechecked", true);
    if (validation.checkAll([true,this.props.streetnumberchecked,this.props.streetchecked,this.props.citychecked,this.props.zipchecked])){
      setTimeout(this.props.updateForm,10,"alladdresschecked", true);
    }

    const stateinput = document.querySelector("label[for='st']");
    stateinput.classList.add("active");
    stateinput.classList.add("activeaddy");

    const sliderdiv = document.getElementById("loanslider");
    if (usstates[i].served === "true"){
      this.props.updateForm("notserved", false);
      this.props.updateForm("stateserved", true);
      if (usstates[i].shortform !== "CA"){
        sliderdiv.classList.add("hidden");
        scroll.scrollTo(250, {duration: 1000});
        setTimeout(()=>{document.querySelector('.rangeslider__handle').focus()},10);
      } else {
        sliderdiv.classList.remove("hidden");
      }
    } else {
      this.props.updateForm("notserved", true);
      this.props.updateForm("stateserved", false);
      sliderdiv.classList.add("hidden");
    }
  }

  onBlurred = (event) => {
    if (!this.stateselected){
      for(var i = 0; i < usstates.length; i++) {
        if(usstates[i].name.toLowerCase() === event.target.value.toLowerCase()) {
          this.setStofRes(i);
          break;
        } else if (usstates[i].shortform.toUpperCase() === event.target.value.toUpperCase()){
          this.setStofRes(i);
          break;
        }
      }
    }
  };

  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      id: "st",
      name: "st",
      autoComplete: "state",
      className: "form-control filled",
      tabIndex:"6",
      placeholder: 'Start typing your state’s name',
      value: this.props.st,
      onChange: this.onChange,
      onBlur: this.onBlurred
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        highlightFirstSuggestion={true}
      />
    );
  }
}

const mapStateToProps = (state) => ({
    st: state.FormReducer.st,
    stt: state.FormReducer.stt,
    street: state.FormReducer.street,
    city: state.FormReducer.city,
    zip: state.FormReducer.zip,
    notserved: state.FormReducer.notserved,
    stateserved: state.FormReducer.stateserved,
    statechecked: state.FormReducer.statechecked,
    statechanged: state.FormReducer.statechanged,
    startapp: state.FormReducer.startapp
})

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value))
})

export default connect(mapStateToProps, mapDispatchToProps)(StateSelector2);



// WEBPACK FOOTER //
// ./src/components/partials/StateSelector2.js